import constantFactory from "@gaoding/constant-factory";

export const {
  LOCAL_STORAGE_KEY,
  LOCAL_STORAGE_KEY_LIST,
  LOCAL_STORAGE_KEY_MAP,
  LOCAL_STORAGE_KEY_ITEM_MAP,
} = constantFactory("LOCAL_STORAGE_KEY", [
  {
    key: "UPDATE_LAST_BOARDS",
    label: "更新最近采集的画板",
    value: "updateLastBoards",
  },
  {
    key: "BOARD_HISTORY",
    label: "画板详情浏览历史记录",
    value: "boardHistory",
  },
  {
    key: "APP_STORE",
    label: "应用状态",
    value: "appStore",
  },
  {
    key: "HB_NOTIFICATION_SYSTEM_DM",
    label: "系统通知消息横幅关闭信息",
    value: "hb-notification-system-dm",
  },
  {
    key: "HB_HEADER_NAV_TAG",
    label: "导航栏链接的红色标识",
    value: "hb-header-nav-tag",
  },
  {
    key: "HB_DOWNLOAD_LIST",
    label: "下载记录浮窗",
    value: "hb-download-list",
  },
  {
    key: "HB_DOWNLOADED_RECORD",
    label: "下载记录浮窗",
    value: "hb-downloaded-record",
  },
  {
    key: "HB_MUTI_SUBJECT_TIP",
    label: "多授权主体提醒",
    value: "hb_muti_subject_tip",
  },
]);
